import { useState, useEffect, useReducer } from 'react';
import useApi, { SEARCH_TIME_SERIES } from 'hooks/useApi';
import { initialState, reducer } from './config';

// TODO: Implement hook properly in Comparative Stats table since it will get broken
const useBenchmarkSearch = () => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const [apiState, sendRequest] = useApi();
  const { data: response, isLoading, isError } = apiState;

  const [results, setResults] = useState([]);

  useEffect(() => {
    if (isError || isLoading || !response) {
      return;
    }

    setResults(response.data);
  }, [response, isLoading, isError]);

  const search = () => {
    const params = SEARCH_TIME_SERIES({ ...state });
    sendRequest(params);
  };

  return [state, dispatch, search, results, apiState];
};

export default useBenchmarkSearch;
